import { Link } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

export interface CellContentCaseLinkProps {
  applicantId: number
  caseNumber: string
}

export const CellContentCaseLink = ({ applicantId, caseNumber }: CellContentCaseLinkProps) => {
  return (
    <Link
      to="/applicants/$applicantId/cases/$caseNumber"
      params={{ applicantId: `${applicantId}`, caseNumber }}
      target="_blank"
      className={cn('underline')}
    >
      {caseNumber}
    </Link>
  )
}
